import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from "rxjs";
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { MensagemService } from '../services/mensagem.service';
import { TreatDate } from '../util/treatDate';

declare var $ :any;

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  providers: [MensagemService]
})
export class MenuComponent extends AbstractComponent implements OnInit {

  tempo: number;
  dataCompleta: string;
  redirecionamento: boolean;
  periodoDia: string;
  nomeCompleto: string;
  primeiroNome: string;

  /**
   * Construtor padrão
   */
  constructor(
    private sessaoService: SessaoService,
    private mensagemService: MensagemService,
    private router: Router) {
    super(sessaoService);
    this.redirecionamento = this.sessao.configuracaoVisual.redirecionar;
    if(sessionStorage.getItem("TEMPO_SESSAO")){
      this.tempo = +sessionStorage.getItem("TEMPO_SESSAO");
    }
    else {
      this.tempo = +this.getMensagem("TEMPO_SESSAO");
      sessionStorage.setItem("TEMPO_SESSAO",this.getMensagem("TEMPO_SESSAO"));
    }

    this.dataCompleta = TreatDate.getDataAtualCompleta();

    // periodoDia
    if(new Date().getHours() < 12){
      this.periodoDia = "Bom dia";
    }
    else if(new Date().getHours() > 12 && new Date().getHours() < 18){
        this.periodoDia = "Boa Tarde";
    }
    else {
        this.periodoDia = "Boa Noite";
    }
  }

  /**
   * Método chamado na inicialização do componente
   */
  ngOnInit() {

    this.nomeCompleto = this.sessao.autenticado.nmCliente;
    this.primeiroNome = this.nomeCompleto.substring(0,this.nomeCompleto.indexOf(' '));

    $(".dropdown-button").dropdown();
    $('.collapsible').collapsible();

    //$('.centrais').mouseover(function(e){
        //$(this).trigger('click');
    //});

    $('.dropdown-central').mouseleave(function(e){
        $('.dropdown-button.centrais').dropdown('close');
    });

    $('.dropdown-outros').mouseleave(function(e){
        $('.dropdown-button.outros').dropdown('close');
    });


    // Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    if (isMobile.matches) {
      // Menu
      $(".mClose").click(function(e) {
        e.preventDefault();
        $(".page").toggleClass("toggled");
      });
    }

    // Parceiros
    if (this.sessaoService.sessao.configuracaoVisual.parceiro.cdParceiro != 1) {
      $( ".bfRodape" ).attr( "style", "background-image: url('assets/img/logo-bradesco-menu.png') !important; background-position: center !important; background-repeat: no-repeat !important" );
    }
    else {
      $( ".bfRodape" ).css("height","0px");
    }

    // Efetua a contagem regressiva
    Observable.interval(60000)
      .takeWhile(() => this.stopCondition())
      .subscribe(i => {
          this.tempo -= 1;
          sessionStorage.setItem("TEMPO_SESSAO",this.tempo + "");
    });
  }

  /**
   * Verifica se o tempo de sessão chegou em zero.
   */
  stopCondition = (): boolean => {
    if(this.tempo != 0){
      return true;
    }
    else {
      sessionStorage.clear();
      this.sessaoService.sessao.logado = false;
      this.sair();
    }

    return false;
  }

  sair = () => {
    if(this.redirecionamento){
      sessionStorage.removeItem("sessao");
      sessionStorage.clear();
      this.sessaoService.sessao.logado = false;
      this.router.navigate(['/redirecionamento']);
    } else{
      window.open('', '_self', '');
      window.close();
      sessionStorage.clear();
      this.sessaoService.sessao.logado = false;
      this.router.navigate(['/login-parceiro']);
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/menu/menu.component.ts